import Axios from 'axios'
import { v4 as uuid } from 'uuid'

const Api = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Authorization': `Bearer ${process.env.REACT_APP_API_TOKEN}`
  }
});


export default Api;